function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#DF1642",
  fillRule: "evenodd",
  d: "M9 12.545a.818.818 0 1 1 0 1.637.818.818 0 0 1 0-1.637zM9 6c.452 0 .818.366.818.818v3.273a.818.818 0 0 1-1.636 0V6.818C8.182 6.366 8.548 6 9 6zm8.64 6.997L11.362 2.408a2.797 2.797 0 0 0-2.366-1.317c-.958 0-1.85.497-2.366 1.317L.35 12.997a2.534 2.534 0 0 0-.04 2.497 2.751 2.751 0 0 0 2.407 1.415h12.559a2.75 2.75 0 0 0 2.406-1.382 2.533 2.533 0 0 0-.04-2.53zm-1.391 1.706c-.2.35-.576.559-.974.541H2.715a1.068 1.068 0 0 1-.973-.541.845.845 0 0 1 0-.832L8.029 3.274c.23-.308.587-.488.966-.488.38 0 .737.18.966.488l6.28 10.588c.152.258.155.58.008.841z"
});

var SvgWarningTriangle = function SvgWarningTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-triangle.8aa068ab.svg";
export { ForwardRef as ReactComponent };